import { Insurance } from "@api/models/Insurance";
import { RestPage } from "@api/models/RestPage";
import { LoadingState } from "@store/common/LoadingState";
import { NgxsDataRepository } from "@angular-ru/ngxs/repositories";
import { Injectable } from "@angular/core";
import { DataAction, StateRepository } from "@angular-ru/ngxs/decorators";
import { Selector, State } from "@ngxs/store";
import { InsuranceHttpService } from "@api/servies/insurance-http.service";
import { Pagination } from "@api/models/Pagination";
import { finalize, tap } from "rxjs";
import { patch, updateItem } from "@ngxs/store/operators";

export interface InsuranceListStateModel {
  items: RestPage<Insurance>;
  selected?: Insurance;
  loading: LoadingState;
}

export const INSURANCE_LIST_STATE_DEFAULT : InsuranceListStateModel = {
  items: new RestPage<Insurance>(),
  loading: LoadingState.IDLE
}

@StateRepository()
@State<InsuranceListStateModel>({
  name: "InsuranceList",
  defaults: INSURANCE_LIST_STATE_DEFAULT
})
@Injectable()
export class InsuranceListState extends NgxsDataRepository<InsuranceListStateModel> {
  constructor(private dataService: InsuranceHttpService) {
    super();
  }

  @Selector()
  static items(state: InsuranceListStateModel) {
    return state.items
  }

  @Selector()
  static getSelected(state: InsuranceListStateModel) {
    return state.selected;
  }

  @Selector()
  static isLoading(state: InsuranceListStateModel) {
    return state.loading === LoadingState.LOADING;
  }

  @DataAction({cancelUncompleted: true})
  get(params: any, pagination: Pagination) {
    this.ctx.patchState({loading: LoadingState.LOADING})
    return this.dataService.getAll(params, pagination).pipe(
      finalize(() => { this.patchState({loading: LoadingState.IDLE})}),
      tap((items: RestPage<Insurance>) => this.patchState({items}))
    )
  }

  @DataAction()
  setSelected(selected: Insurance) {
    this.ctx.patchState({selected})
  }

  @DataAction()
  update(item: Insurance) {
    this.ctx.patchState({loading: LoadingState.SAVING})
    return this.dataService.update(item).pipe(
      finalize(() => { this.patchState({loading: LoadingState.IDLE})}),
      tap((updated: Insurance) => this.setState(patch({ items: patch({ content: updateItem<Insurance>(i => i?.id === updated.id, updated) }), selected: item})))
    )
  }
}
